(function () {
  const el = document.getElementById("deJournalSlideout");
  if (!el) return;

  // Only on eligible pages
  const pageType = el.getAttribute("data-page-type");
  if (!["article", "product", "collection"].includes(pageType)) return;

  // Context comes from the liquid snippet: 'journal' | 'shop' | 'tlc'.
  // Each context now gets its own suppression key/window instead of one shared key.
  const context = el.getAttribute("data-slideout-context") || "shop";
  const STORAGE_KEY = "deSlideoutSeenAt_" + context;
  const COOLDOWN_DAYS = 2;

  // Per-page delay (no scroll gating) — unchanged
  const DELAY_PRODUCT_MS = 15000; // products + collections (also covers TLC)
  const DELAY_JOURNAL_MS = 20000; // journal articles

  function getDelayMs(type) {
    return type === "article" ? DELAY_JOURNAL_MS : DELAY_PRODUCT_MS;
  }

  function now() { return Date.now(); }

  function seenRecently() {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (!v) return false;
      const last = parseInt(v, 10);
      if (!Number.isFinite(last)) return false;
      const ms = COOLDOWN_DAYS * 24 * 60 * 60 * 1000;
      return (now() - last) < ms;
    } catch (e) {
      return false;
    }
  }

  function markSeen() {
    try { localStorage.setItem(STORAGE_KEY, String(now())); } catch (e) {}
  }

  function show() {
    if (el.classList.contains("is-visible")) return;
    el.classList.add("is-visible");
    el.setAttribute("aria-hidden", "false");
    markSeen();
  }

  function hide() {
    el.classList.remove("is-visible");
    el.setAttribute("aria-hidden", "true");
    markSeen();
  }

  const closeBtn = el.querySelector(".de-journal-slideout__close");
  if (closeBtn) closeBtn.addEventListener("click", hide);

  if (seenRecently()) return;

  // Timer only (no scroll condition)
  const delayMs = getDelayMs(pageType);
  setTimeout(function () {
    if (seenRecently()) return;
    show();
  }, delayMs);

  // -------------------------------------------------------------------
  // Stay Connected — expand/replace the actions area with an email form.
  // No navigation away from the page in any case (success or error).
  //
  // Persistence: the form itself (see journal-engage-slideout.liquid)
  // posts to Shopify's native /contact endpoint with form_type=customer.
  // That's Shopify's own newsletter-signup mechanism — every submission
  // is saved as a real Customer record in Shopify Admin, tagged
  // "newsletter, stay-connected-{context}". This is the fix for entries
  // going missing: the data lives in Customers regardless of whether any
  // notification email is delivered.
  //
  // Notification: alongside that, this also fires a second, best-effort
  // request to Shopify's native /contact endpoint with form_type=contact,
  // which is the mechanism that triggers the store's "Contact form"
  // notification email. If no email is arriving, the most likely cause is
  // the recipient address under Shopify Admin → Settings → Notifications
  // → "Contact form" — worth checking there. Either way, the subscriber
  // is never lost: it's already saved as a Customer by the primary request.
  //
  // Both Shopify requests use mode: "no-cors" (see the submit handler
  // below for why) — the trade-off is that a validation failure Shopify
  // renders back into the page (e.g. a malformed email it rejects outright)
  // can't be distinguished from success purely over the network. The email
  // input's own required/type="email" validation catches the common case
  // before it's ever sent.
  //
  // To switch to Zoho Campaigns once you have that form's details: set
  // ZOHO_FORM_ACTION below to the Zoho form action URL, and if Zoho gave
  // you a specific email field name (not "contact[email]"), rename the
  // "name" attribute on the email input in journal-engage-slideout.liquid
  // to match. Setting ZOHO_FORM_ACTION replaces both requests below with a
  // single submission to Zoho instead.
  // -------------------------------------------------------------------
  const ZOHO_FORM_ACTION = null; // e.g. "https://campaigns.zoho.eu/subscribe/xxxxx"

  const CONTEXT_LABELS = { journal: "Journal", shop: "Shop", tlc: "Licensing" };

  const trigger = el.querySelector("[data-stay-trigger]");
  const actions = el.querySelector("[data-slideout-actions]");
  const stayWrap = el.querySelector("[data-stay-wrap]");
  const stayForm = el.querySelector("[data-stay-form]");
  const stayError = el.querySelector("[data-stay-error]");
  const staySuccess = el.querySelector("[data-stay-success]");
  const kicker = el.querySelector("[data-slideout-kicker]");
  const intro = el.querySelector("[data-slideout-intro]");

  if (trigger && actions && stayWrap && stayForm) {
    trigger.addEventListener("click", function () {
      actions.hidden = true;
      stayWrap.hidden = false;
      stayWrap.classList.add("is-active");
      const emailInput = stayForm.querySelector('input[type="email"]');
      if (emailInput) emailInput.focus();
    });

    function sendAdminNotification(email, tags, stayContext) {
      // Best-effort only, and uses the same no-cors approach as the primary
      // send below — see the note in the submit handler for why.
      try {
        const notifyData = new FormData();
        notifyData.append("form_type", "contact");
        notifyData.append("utf8", "✓");
        notifyData.append("contact[email]", email);
        notifyData.append("contact[tags]", tags);
        notifyData.append(
          "contact[subject]",
          "Stay Connected sign-up — " + (CONTEXT_LABELS[stayContext] || stayContext)
        );
        notifyData.append(
          "contact[body]",
          "New Stay Connected sign-up (" + stayContext + "): " + email + "\nPage: " + window.location.href
        );
        fetch("/contact", { method: "POST", body: notifyData, mode: "no-cors" }).catch(function () {});
      } catch (e) {}
    }

    stayForm.addEventListener("submit", function (evt) {
      evt.preventDefault();
      if (stayForm.classList.contains("is-submitting")) return;

      if (stayError) stayError.hidden = true;
      stayForm.classList.add("is-submitting");

      const formData = new FormData(stayForm);
      const email = formData.get("contact[email]");
      const tags = formData.get("contact[tags]");
      const stayContext = stayForm.getAttribute("data-stay-context") || context;

      const endpoint = ZOHO_FORM_ACTION || stayForm.getAttribute("action").split("#")[0];

      // mode: "no-cors" for every case here (Shopify's own /contact endpoint
      // included, not just Zoho). Shopify's /contact endpoint responds with a
      // redirect on success, and that redirect can land on a different host
      // variant (e.g. www vs bare domain) than the page the form was
      // submitted from. With mode: "same-origin" the browser treats that as a
      // cross-origin redirect and throws, even though Shopify already
      // processed the submission — which was showing visitors an error
      // message on a submission that had, in fact, worked, and was skipping
      // the admin-notification request entirely as a result. no-cors sends
      // the same request and sidesteps that: we can no longer read the
      // response, but a resolved fetch() (vs. a thrown network error) is
      // enough to treat the send as successful.
      fetch(endpoint, {
        method: "POST",
        body: formData,
        mode: "no-cors",
      })
        .then(function () {
          if (!ZOHO_FORM_ACTION) sendAdminNotification(email, tags, stayContext);
          stayForm.hidden = true;
          if (kicker) kicker.hidden = true;
          if (intro) intro.hidden = true;
          if (staySuccess) staySuccess.hidden = false;
        })
        .catch(function () {
          // A genuine network failure (offline, DNS, blocked request) still
          // lands here and shows the error state as before.
          if (stayError) stayError.hidden = false;
        })
        .finally(function () {
          stayForm.classList.remove("is-submitting");
        });
    });
  }

})();
